// versions/noticeWarnComponents.js
// 101-104 版共用的須知警語小元件，逐字搬自原 notice.jsx 頂部（L10-24）。
// 105 版警語文字不同（見 versions/v105/notice.js 內自帶的 <Alert>），不共用此檔案。
import React from 'react';
import { Alert } from "@curves/ui-base";

export const WarnComponent = () => {
    return (
        <Alert variant="filled" severity="info" color="info">
            為了提供理想的運動環境，若有未能遵守以上事項者，店舖有權禁止運動。
        </Alert>
    );
};

export const WarnComponentWithMembershipBenefits = () => {
    return (
        <Alert className="mb-3" severity="info" variant="filled" color="info">
            因涉及會員權益與金額之認定，務必親自赴所屬店舖辦理。
        </Alert>
    );
};
